import React, { Component } from 'react';
import { Button, Icon, Col, Row } from 'react-materialize';

import EventUtils from '../../utils/EventUtils';

import './OptionsSelector.css';

class OptionsSelector extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: props.selected ? props.selected : []
        }

        this._handleRemoveClick = this._handleRemoveClick.bind(this);
        this._handleAddClick = this._handleAddClick.bind(this);
    }

    get selected() {
        return this.state.selected;
    }

    set selected(selected) {
        this.setState({ selected: selected });
    }

    _handleRemoveClick(event) {
        let currentSelected = this.selected;
        let selectedOptions = window.$('#selected').get(0).options;

        for (let i = 0; i < selectedOptions.length; i++) {
            let selectedOption = selectedOptions[i];

            if (!selectedOption.selected) {
                continue;
            }

            currentSelected = currentSelected.filter(option => option !== selectedOption.value);
        }

        this.selected = currentSelected;
        EventUtils.raiseEvent('changed', { selected: currentSelected }, this.props);
    }

    _handleAddClick(event) {
        let currentSelected = this.selected;
        let selectedOptions = window.$('#options').get(0).options;

        for (let i = 0; i < selectedOptions.length; i++) {
            let selectedOption = selectedOptions[i];

            if (!selectedOption.selected) {
                continue;
            }

            if (currentSelected.includes(selectedOption.value)) {
                continue;
            }

            currentSelected.push(selectedOption.value);
        }

        this.selected = currentSelected;
        EventUtils.raiseEvent('changed', { selected: currentSelected }, this.props);
    }

    render() {
        const { options, optionsLabel, selectionLabel } = this.props;
        const { selected } = this.state;

        let optionsValues = Object.keys(options);
        let selectedOptionsValues = optionsValues.filter(option => selected.includes(option));
        let notSelectedOptionsValues = optionsValues.filter(option => !selected.includes(option));

        return (
            <div className="options-selector">
                <Row>
                    <Col s={5}>
                        <label className="active">{ optionsLabel }</label>
                        <select id="options" multiple style={ { display: 'block' } }>
                            {
                                notSelectedOptionsValues.map((option, id) => <option key={id} value={ option }>{ options[option] }</option>)
                            }
                        </select>
                    </Col>
                    <Col s={1}>
                        <Button floating disabled={ selectedOptionsValues.length === 0 } onClick={ this._handleRemoveClick }>
                            <Icon>arrow_back_ios</Icon>
                        </Button>
                    </Col>
                    <Col s={1}>
                        <Button floating disabled={ notSelectedOptionsValues.length === 0 } onClick={ this._handleAddClick }>
                            <Icon>arrow_forward_ios</Icon>
                        </Button>
                    </Col>
                    <Col s={5}>
                        <label className="active">{ selectionLabel }</label>
                        <select id="selected" multiple style={ { display: 'block' } }>
                            {
                                selectedOptionsValues.map((option, id) => <option key={id} value={ option }>{ options[option] }</option>)
                            }
                        </select>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default OptionsSelector;